import React, { Fragment, useState, useEffect } from 'react';
import { post } from '../../Services/http';
import { googleAnalytics } from '../../Services/googleAnalytics';
import constants from '../../constants';
import InventoryPopup from './InventoryPopup';
import { translate } from '../../Services/translation';

const InventoryItem = ({product, trClassName, setProducts}) => {

  const [quantiy, setQuantity] = useState(product.quantityInStock);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const removeItem = () => {
    post('/api/inventoryedit/removeitem?variantSystemId=' + product.systemId)
    .then(response => response.json())
    .then(result => {
      setProducts(result);
      setConfirmOpen(false);
    })
  }

  useEffect(() => {
    setQuantity(product.quantityInStock);
  }, [product])

  const updateQuantity = (elementId, value) => {
    var elementId = document.getElementById(elementId);
    elementId.value = parseInt(elementId.value) + value;
    if (elementId.value <= 0) {
      elementId.value = 0;
    }
    setQuantity(elementId.value);

    post('/api/inventoryedit/edititem?variantSystemId=' + product.systemId + '&newQuantity=' + elementId.value)
    .then(response => response.json())
    .then(result => {
      setProducts(result)
      googleAnalytics({'event': 'click_and_collect_stock_change',
        'reseller': constants.dealerERPID,
        'reseller_id': constants.organizationName,
        'article_number': product.id})
    })
  }

  return (
    <Fragment>
      <tr itemScope itemType="http://schema.org/Product"
        className={product.isExpired
            ? 'product-list-view product-list-view--expired ' + trClassName
            : 'product-list-view ' + trClassName}>
        <td>
          <figure className="product__figure">
            <a href={product.url} title={product.name}>
              <div dangerouslySetInnerHTML={{ __html: product.imageUrl }}></div>
            </a>
          </figure>
        </td>
        <td className="name">
          <a href={product.Url} title={product.name}>
            {product.name}
          </a>
        </td>
        <td className="value spec" key={'ProSpec' + 0}>
          {product.id ? product.id : ''}
        </td>
        <td colSpan="0" align="right">
          <div className="list-view--actions inventory_edit--actions">
            <div className="checkout-cart__quantity">
              <span className="controller" onClick={() => { updateQuantity(product.quantityFieldId, -1)}}>
                -
              </span>
              <input
                id={product.quantityFieldId}
                type="number"
                data-buy-quantity-input
                value={quantiy}
                min="0"
                max="999"
                maxLength="3"
                onChange={(event) => setQuantity(event.target.value)}
                className="product__buy-quantity form__input"
              />
              <span className="controller" onClick={() => {updateQuantity(product.quantityFieldId, 1)}}>
                +
              </span>
            </div>
          </div>
        </td>
        <td colSpan="0" align="left">
            <span
                className={`inventoryEdit__button inventoryEdit__button--small active`}
                onClick={() => updateQuantity(product.quantityFieldId, 0)}>
                    ✓
            </span>
          </td>
        <td colSpan="0" align="left">
          <span className={`inventoryEdit__button inventoryEdit__button--small active`}
              onClick={() => {
                setConfirmOpen(true);
              }}>
            🗑
          </span>
          <InventoryPopup
            isOpen={confirmOpen}
            setOpen={setConfirmOpen}
            onClose={setConfirmOpen}
            component={
              <Fragment>
                  <h3>{translate('brenderup.inventoryedit.confirmremoval')}</h3>
                  <button onClick={() => removeItem()}>{translate('brenderup.inventoryedit.removeproduct')}</button>
              </Fragment>
            }
          />
        </td>
      </tr>
    </Fragment>
  )
}

export default InventoryItem;